// extracted by mini-css-extract-plugin
export default {"header":"StudentDashboard_header__xxQ2q","logo":"StudentDashboard_logo__Lx5sq","dashboard":"StudentDashboard_dashboard__nUAuo","subPage":"StudentDashboard_subPage__fvQFu"};